import { render, staticRenderFns } from "./LuggageInfoAndPhotos.vue?vue&type=template&id=1be2542a"
import script from "./LuggageInfoAndPhotos.vue?vue&type=script&lang=js"
export * from "./LuggageInfoAndPhotos.vue?vue&type=script&lang=js"
import style0 from "./LuggageInfoAndPhotos.vue?vue&type=style&index=0&id=1be2542a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports